import React from 'react'
import Layout from '../Layout'
import DataTable from '../../../Components/DataTable'
import Button from '../../../Components/Button'
import ResourceIndexHeader from '../../../Components/ResourceIndexHeader'
import { useDeleteWithConfirmation } from '../../../hooks/useDeleteWithConfirmation'

export default function Index({
  account,
  accounts,
  navigation,
  capabilities,
  is_admin
}) {
  const handleDelete = useDeleteWithConfirmation('/manage/capabilities')

  const columns = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      render: (value, item) => (
        <div>
          <div className="font-medium text-gray-900">{value}</div>
          {item.description && (
            <div className="text-gray-500 text-sm truncate max-w-xs">{item.description}</div>
          )}
        </div>
      )
    },
    {
      key: 'venue_count',
      label: 'Venues',
      className: 'text-gray-500'
    },
    {
      key: 'active',
      label: 'Status',
      render: (value) => (
        <span className={`inline-flex rounded-full px-2 py-1 text-xs font-semibold ${
          value ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
        }`}>
          {value ? 'Active' : 'Inactive'}
        </span>
      )
    }
  ]

  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="Amenities"
      is_admin={is_admin}
    >
      <ResourceIndexHeader
        count={capabilities.length}
        singular="amenity"
        plural="amenities"
        addHref="/manage/capabilities/new"
        addLabel="Add Amenity"
      />

      <DataTable
        data={capabilities}
        columns={columns}
        actions={(item) => (
          <>
            <Button link href={`/manage/capabilities/${item.id}/edit`}>Edit</Button>
            <Button link variant="danger" onClick={() => handleDelete(item)}>Delete</Button>
          </>
        )}
        searchable={true}
        searchPlaceholder="Search amenities..."
        emptyState={{
          message: 'No amenities found',
          action: { label: 'Add your first amenity', href: '/manage/capabilities/new' }
        }}
        baseUrl="/manage/capabilities"
      />
    </Layout>
  )
}
